/**
 * Top-level content mode of an AI-generated speach. Drives which style blocks
 * are shown (avatar / explainer / voice-only) and which subchapter types the
 * LLM may emit:
 *  - FULL_SLIDE     → avatar + slides (no explainer)
 *  - MIXED          → avatar + slides + video explainer
 *  - FULL_EXPLAINER → voice-only, 100% video explainer (no avatar, no slide)
 *
 * "Preserve document" is NOT a content mode — it is the STRICT SlideGenerationMode
 * (see generationModeEnum). It reuses the FULL_SLIDE layout but keeps the source
 * document content strictly. The options step exposes the 4 as a single choice.
 */
export enum ContentMode {
  FULL_SLIDE = "FULL_SLIDE",
  MIXED = "MIXED",
  FULL_EXPLAINER = "FULL_EXPLAINER",
}
